/*
 * File: /src/pages/install/install-payment-confirm.vue
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Monday, 16th July 2018 2:57:21 pm
 * Last Modified: Wednesday, 29th August 2018 1:54:41 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */
<template>
    <p class="install-msg">
        Payment confirmation
    </p>
</template>
<script>
  export default {
    async mounted() {
        try {
            const { status } = await this.$store.dispatch('shop/CHARGE_CONFIRM', { chargeId: this.$route.query.charge_id })
            
            if (status === 'active') {
                this.$store.commit('modals/SET_MODAL_TO_FORCE', { modal: 'ModalTutorial'})
                this.$router.push({name: 'home'})
            } else {
                console.error('Payment declined')
                this.$router.push({name: 'install.payment.decline'})
            }
        } catch (error) {
            console.error(`Couldn't get payment redirect url`, error)
            this.$router.push({name: 'error'})
        }
    } 
  }
</script>



// WEBPACK FOOTER //
// src/pages/install/install-payment-confirm.vue